export default "__VITE_ASSET__92d8a966__"